import SloganSG from './SloganSG.jsx';
import './SloganSG.css';

export default SloganSG;
